module.exports = __webpack_public_path__ + "img/pinghengkuai.prt.65bdc1ef.jpg";